
import isEmpty from 'lodash/isEmpty'

import { isNumber } from '@core/helpers'

import RateBlock from '../Page/components/RateBlock'
import ReviewsList from '../Page/components/ReviewsList'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './Block.constants'
import translations from './Block.translations'

export default {
  components: {
    ReviewsList,
    RateBlock,
  },
  props: {
    isPlaceholder: {
      type: Boolean,
      default: false,
    },
    reviews: {
      type: Array,
      required: true,
    },
    globalRate: {
      type: Object,
      required: true,
    },
    summary: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    buttonLabel: {
      type: String,
      default: null,
    },
  },
  computed: {
    translations: () => translations,
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
    buttonLabelWithDefault() {
      return this.buttonLabel || this.$t(translations.loadMore)
    },
    areReviewsEmpty() {
      return isEmpty(this.reviews)
    },
    resourceHasRate() {
      return (
        isNumber(this.globalRate.averageRate) &&
        isNumber(this.globalRate.reviewsCount)
      )
    },
    isOriginalReviewsWithRate() {
      return this.resourceHasRate && !this.isPlaceholder
    },
    isFullGrid() {
      return this.isPlaceholder || !this.isOriginalReviewsWithRate
    },
    reviewsTrackingInfo() {
      return {
        pageType: this.$route.name,
        averageRate: this.globalRate.averageRate,
      }
    },
  },
}
